// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!../index.html');
  require('raw-loader!../_main.html');
}

// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';

import * as service from './service';
service.init();

import $ from 'jquery';
import '../lib/swiper';
import '../scss/swiper.scss';
import * as interaction from './interaction.js';
import { getParam } from 'utilsES';
import { initReport } from './reserveDataReport.js';
$(function () {
  dataLayer.push({
    event: 'entrance',
    scid: getParam('scid'),
    cid: getParam('cid'),
  });

  // const fullpageAPI = interaction.initFullPage();
  // 需要先请求完平台的接口 再请求后台活动接口
  // interaction.user
  //   .init()
  //   .then(() => {
  //     interaction.preNum.init();
  //     interaction.wakeNum.init();
  //     interaction.share.init();
  //   });
  // interaction.fb.init();
  // interaction.wake.init();
  // interaction.common.init();
  interaction.mutiCidGpLinkInit();
  interaction.preNum.init();
  interaction.menu.init();
  interaction.register.init();
  interaction.download.init();
  // interaction.world.init();
  interaction.role.init();
  // interaction.footer.init();
  interaction.login.initLogin();
  interaction.menhui.init();
  interaction.commonEvent();
  initReport();
});

// 商品轮播
window.addEventListener('load', () => {
  // // 视频延迟加载
  // const tpl = `<source src="./vedio/pc_vedio1.webm" type="video/webm">
  // 							<source src="./vedio/pc_vedio2.mp4" type="video/mp4">`;
  // const $vedio = $('.j-vedio');
  // $vedio.html(tpl);
  // $vedio.on('canplay', () => {
  //   $('.j-vedio-container').addClass('active');
  // });

  // 轮播图初始化
  const shopSwiper = new Swiper('.part5 .swiper-container', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 5,
    autoplay: true,
    observer: true,
    resizeObserver: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      progress: function (progress) {
        for (let i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          var slideProgress = this.slides[i].progress;
          let modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          let translate = ((slideProgress * modify * 212) / 1920) * 100 + 'vw';
          let scale = 1 - Math.abs(slideProgress) / 5;
          let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          if (Math.abs(slideProgress) > 3) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function (transition) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          slide.transition(transition);
        }
      },
      resize() {
        // let width = $('.part4 .swiper-container').width();
        // $('.part4 .swiper-container img').css('width', `${width}px`);
      },
    },
  });
  setTimeout(() => {
    shopSwiper.update();
  }, 1500);
});
